import {
  Modal as ChakraModal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay as ChakraModalOverlay,
  ModalProps as ChakraModalProps,
  ModalCloseButton,
} from "@chakra-ui/react";

export type ModalProps = ChakraModalProps;

export function Modal({ children, ...rest }: ModalProps) {
  return (
    <ChakraModal {...rest}>
      <ChakraModalOverlay bg="rgba(0,0,0,0.2)" />
      {children}
    </ChakraModal>
  );
}

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
